import { Card } from 'antd';
import styled from 'styled-components';

export const StyledCard = styled(Card)`
  .ant-card-head {
    padding-right: 12px;

    .ant-card-head-title {
      display: flex;
      align-items: center;
      gap: 8px;
      line-height: 1;
      font-weight: 500;
    }

    .ant-tabs-tab {
      padding-block: 21px;
      font-size: 14px;
    }
    .ant-tabs-tab-btn {
      display: flex;
      align-items: center;
      gap: 5px;
      line-height: 1;
    }

    .ant-card-extra {
      display: flex;
      align-items: center;
      gap: 4px;
    }
  }

  .ant-tabs-nav-wrap {
    overflow: unset !important;
  }

  .ant-tabs-nav-list {
    flex-wrap: wrap !important;
  }

  .ant-tabs-tab-active {
    border-bottom: 2px solid #526a99;
  }

  .ant-tabs-ink-bar {
    background-color: transparent !important;
  }

  .ant-card-body {
    padding: 0;
  }
`;

export const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: right;
  gap: 8px;
  padding: 0 24px;
  line-height: 1;
  height: 60px;
  border-top: 1px solid var(--borderColor);
  background-color: rgba(0, 0, 0, 0.02);
`;
